module.exports = __webpack_public_path__ + "static/13-6cbb4d5711e04d5f05f3488335d4720f.png";